// extracted by mini-css-extract-plugin
module.exports = {"form":"AddCategory_form__OqxWx","innerform":"AddCategory_innerform__28cGK","label-input":"AddCategory_label-input__23RPU","buttondiv":"AddCategory_buttondiv__1KLqk"};